// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCG1QviVtBp7ryc97_a04zIYyxgnd-TqKg",
  authDomain: "darts-ranking.firebaseapp.com",
  projectId: "darts-ranking",
  storageBucket: "darts-ranking.appspot.com",
  messagingSenderId: "968211732639",
  appId: "1:968211732639:web:4160326a1a6e5521952aaa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app) 

export const database = getFirestore(app)

export default app